<template>
  <footer class="footer">
    <!-- <div class="top">
      <div class="logo">
        <svg-icon iconClass="logo" className="a"></svg-icon>
      </div>
      <ul class="menu">
        <li v-for="item in menuList" :key="item.id">
          <a href="">{{ item.title }}</a>
        </li>
      </ul>
      <div class="iconSet">
        <svg-icon iconClass="message" className="middle"></svg-icon>
        <svg-icon iconClass="in" className="middle"></svg-icon>
        <svg-icon iconClass="youtube" className="middle"></svg-icon>
      </div>
    </div>
    <div class="middle">
      <a href="">Connect & Drive with Magnetics</a>
      <div class="searchForm">
        <input type="text" placeholder="SEARCH" />
        <div class="Searchicon">
          <svg-icon iconClass="search" className="search"></svg-icon>
        </div>
      </div>
    </div>
    <div class="bottom">
      <p class="copyright">Copyright © 2022 CMR. All rights reserved.</p>
      <div class="privacy">
        <a href="">Privacy Policy</a>
        <a href="">Terms & Conditions</a>
      </div>
    </div> -->
    <div class="top">
      <div class="left">
        <div class="logo" @click="toIndex">
          <!-- <svg-icon iconClass="logo" className="a"></svg-icon> -->
          <img src="@/assets/images/header/PINK@4x.png" alt="" />
        </div>
        <a href="">{{ $t("footer.contact") }}</a>
        <div class="cmr-location location" @click="locationToWebMapOrApp">
          <div class="icon">
            <svg-icon iconClass="footer-loaction"></svg-icon>
          </div>
          {{ $t("footer.location") }}
        </div>
        <div class="cmr-location">
          <div class="icon">
            <svg-icon iconClass="footer-tel"></svg-icon>
          </div>
          {{ $t("footer.Number") }}
        </div>
        <div class="iconSet">
          <div @click="sendmail">
            <svg-icon iconClass="message"></svg-icon>
          </div>
          <div @click="toLinkin">
            <svg-icon iconClass="in"></svg-icon>
          </div>
          <!-- <div><svg-icon iconClass="youtube"></svg-icon></div> -->
        </div>
        <!-- <div class="searchForm">
          <input type="text" placeholder="SEARCH" />
          <div class="Searchicon">
            <svg-icon iconClass="search"></svg-icon>
          </div>
        </div> -->
      </div>
      <div class="right">
        <div class="menuList" v-for="(item, index) in menuList" :key="item.id">
          <div class="title">
            <router-link :to="item.path" class="link1">{{
              $t("footer.menuList[" + index + "].title")
            }}</router-link>
          </div>
          <div class="footer-items">
            <router-link
              @click.native="appHref(item.title, subitem.title)"
              :to="subitem.path"
              v-for="(subitem, sindex) in item.children"
              :key="subitem.id"
              class="link"
              >{{
                $t(
                  "footer.menuList[" +
                    index +
                    "].children[" +
                    sindex +
                    "].title"
                )
              }}</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="left-bottom">{{ $t("footer.copyright") }}</div>
      <div class="right-bottom">
        <router-link to="/privacy">{{ $t("footer.privacy") }}</router-link>
        <router-link to="/termsConditions">{{ $t("footer.use") }}</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
import { setItem } from "@/utils/localStorage";
// import { loadBMap } from "@/utils/map";
import SystemLANG from "@/utils/languageType";
export default {
  name: "CmrFooter",
  data() {
    return {
      menuList: [
        {
          id: 0,
          title: "Company",
          path: "/company",
          children: [
            {
              id: 0,
              title: "About us",
              path: { path: "/company", query: { md: "com-about-us" } },
            },
            {
              id: 1,
              title: "History",
              path: { path: "/company", query: { md: "com-history" } },
            },
            {
              id: 2,
              title: "ESG",
              path: { path: "/company", query: { md: "com-esg" } },
            },
            // {
            //   id: 3,
            //   title: "Resources",
            //   path: { path: "/resourse" },
            // },
          ],
        },
        {
          id: 1,
          title: "Solutions",
          path: "/solutions",
          children: [
            {
              id: 0,
              title: "Products",
              path: {
                path: "/solutions",
                query: { md: "solutions-products" },
              },
            },
            {
              id: 1,
              title: "Automotive",
              path: {
                name: "applications",
                params: {
                  activeTab: "Automotive",
                  md: "Automotive",
                },
              },
            },
            {
              id: 2,
              title: "Consumer Electronics",
              path: {
                name: "applications",
                params: {
                  activeTab: "Consumer Electronics",
                  md: "Convenient Life",
                },
              },
            },
            {
              id: 3,
              title: "New Energy",
              path: {
                name: "applications",
                params: {
                  activeTab: "New Energy",
                  md: "Eco-friendly resource",
                },
              },
            },
            {
              id: 4,
              title: "Industrial",
              path: {
                name: "applications",
                params: {
                  activeTab: "Home Appliances",
                  md: "Innovative Home",
                },
              },
            },
          ],
        },
        {
          id: 2,
          title: "Capabilities",
          path: "/capabilities",
          children: [
            {
              id: 0,
              title: "What We Do",
              path: { path: "/capabilities", query: { md: "capa-wwd" } },
            },
            {
              id: 1,
              title: "Featured technologies",
              path: { path: "/capabilities", query: { md: "capa-quality" } },
            },
          ],
        },
        {
          id: 3,
          title: "Contact",
          path: "/contact",
          children: [
            {
              id: 0,
              title: "Life at cmr",
              path: { path: "/contact", query: { md: "contact-life" } },
            },
            {
              id: 1,
              title: "Career",
              path: { path: "/contact", query: { md: "contact-career" } },
            },
            {
              id: 2,
              title: "Contact Us",
              path: { path: "/contact", query: { md: "contact-contactus" } },
            },
          ],
        },
      ],
      location: {
        lng: 0,
        lat: 0,
      },
    };
  },
  methods: {
    toIndex() {
      this.$router.push("/home");
    },
    sendmail() {
      window.location.href = "mailto:info@cmr.xyz";
    },
    appHref(father, son) {
      if (father == "Solutions") {
        if (son == "Automotive") {
          setItem("app_tab", "Automotive");
          setItem("app_md", "Automotive");
        }
        if (son == "Consumer Electronics") {
          setItem("app_tab", "Consumer Electronics");
          setItem("app_md", "Convenient Life");
        }
        if (son == "New Energy") {
          setItem("app_tab", "New Energy");
          setItem("app_md", "Eco-friendly resource");
        }
        if (son == "Industrial") {
          setItem("app_tab", "Home Appliances");
          setItem("app_md", "Innovative Home");
        }
      }
    },
    locationToWebMapOrApp() {
      if (SystemLANG == "zh-cn") {
        // this.getCurrentLocation();
        window.open(
          "http://api.map.baidu.com/place/detail?uid=e26517278a4e9e8b16c905e7&output=html&src=webapp.baidu.openAPIdemo",
          "_blank"
        );
      } else {
        window.open(
          "https://www.google.com/maps/place/?q=place_id:ChIJl44thazGSzQRtVMWePsoRY0",
          "_blank"
        );
      }
    },
    toLinkin() {
      window.open("https://www.linkedin.com/company/hangzhou-cmr-polymagnet/");
    },
    // getCurrentLocation() {
    //   //获取地址
    //   const geolocation = new BMapGL.Geolocation();
    //   let _this = this;
    //   geolocation.getCurrentPosition(function (r) {
    //     _this.location.lng = r.point.lng;
    //     _this.location.lat = r.point.lat;
    //     console.log(r);
    //   });
    // },
  },
  mounted() {
    //获取经纬度
    // loadBMap("GWevRzFvphdCNrezlMjoap2KuEAGmi5t");
  },
};
</script>

<style scoped lang="less">
// .footer {
//   display: flex;
//   flex-direction: column;
//   background-color: #000000;
//   padding: 1.8rem;
//   margin-top: 1.2rem;
//   .top {
//     display: flex;
//     line-height: 1rem;
//     height: 1rem;
//     justify-content: space-between;
//     .menu {
//       display: flex;
//       margin-left: auto;
//       li {
//         font-size: 0.2rem;
//         margin-right: 0.7rem;
//       }
//     }
//     .iconSet {
//       display: flex;
//       align-items: center;
//     }
//   }
//   .middle {
//     display: flex;
//     height: 0.5rem;
//     line-height: 0.5rem;
//     justify-content: space-between;
//     a {
//       font-size: 0.23rem;
//     }
//     .searchForm {
//       display: flex;
//       border-bottom: 0.025rem solid #d4d4d4;
//       input {
//         border: none;
//         color: white;
//         background-color: #1a1a1a;
//         outline: none;
//         width: 2.5rem;
//       }
//       .Searchicon {
//         display: flex;
//         align-items: center;
//       }
//     }
//   }
//   .bottom {
//     display: flex;
//     line-height: 0.4rem;
//     height: 0.4rem;
//     justify-content: space-between;
//     border-top: 0.025rem solid #767676;
//     margin-top: 1.2rem;
//     padding-top: 0.2rem;
//     .copyright {
//       font-size: 0.1rem;
//       color: white;
//     }
//     .privacy {
//       display: flex;
//       a {
//         font-size: 0.1rem;
//       }
//     }
//   }
// }
.footer {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding: 0.6rem 0.6rem;
  box-shadow: -0.209px -3.995px 21px 0 rgb(0 0 0 / 6%);
  margin-top: 1.2rem;
  .top {
    display: flex;
    justify-content: space-between;
    // border-bottom: 0.025rem solid #000000;
    // padding-bottom: 0.5rem;
    .left {
      display: flex;
      flex-direction: column;
      width: 6rem;

      .logo {
        font-size: 1rem;
        cursor: pointer;
        // margin-bottom: 0.4rem;
        width: 3rem;
        // background-color: rgb(0, 0, 0);
        img {
          width: 1.4rem;
        }
      }
      .iconSet {
        display: flex;
        align-items: center;
        margin: 0.2rem 0;
        // height: 1.5rem;
        font-size: 0.5rem;
        div {
          font-size: 0.35rem;
          margin-right: 0.1rem;
          cursor: pointer;
        }
      }
      .cmr-location {
        display: flex;
        margin-top: 0.2rem;
        font-size: 0.22rem;
        line-height: 1.6;
        margin-right: 0.5rem;
        color: rgba(0, 0, 0, 0.502);
        .icon {
          margin-top: 0rem;
          margin-right: 0.1rem;
          font-size: 0.25rem;
        }
      }
      .location {
        &:hover {
          cursor: pointer;
        }
      }
      a {
        font-size: 0.22rem;
        height: 0.5rem;
        color: rgba(0, 0, 0, 0.502);
      }
      .searchForm {
        display: flex;
        border-bottom: 0.025rem solid #000000;
        width: 3.5rem;
        input {
          border: none;
          color: rgb(0, 0, 0);
          background-color: #ffffff;
          outline: none;
          height: 0.4rem;
          width: 3.2rem;
        }
        .Searchicon {
          font-size: 0.38rem;
          display: flex;
          align-items: center;
        }
      }
    }
    .right {
      flex: 1;
      display: flex;
      font-size: 0.22rem;
      padding-top: 0.6rem;
      margin-left: 0.5rem;
      justify-content: space-between;
      .menuList {
        // width: 2.3rem;
        // margin-left: 1rem;
        &:first-child {
          margin-left: 0rem;
        }
        .title {
          .link1 {
            color: rgba(0, 0, 0, 0.502);
            // padding: 0.2rem 0;
            font-weight: 500;
            padding-bottom: 0.5rem;
            display: block;
            font-size: 0.22rem;
            transition: all 0.5s;

            &:hover {
              color: #b94060;
            }
          }
        }
        .link {
          color: rgba(0, 0, 0, 0.502);
          // padding: 0.2rem 0;
          padding-bottom: 0.1rem;
          font-size: 0.22rem;
          transition: all 0.5s;
          &:hover {
            color: #b94060;
          }
        }
        .footer-items {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    padding: 0.4rem 0;
    .left-bottom {
      color: rgba(0, 0, 0, 0.502);
      font-size: 0.22rem;
    }
    .right-bottom {
      display: flex;

      a {
        font-size: 0.22rem;
        transition: all 0.5s;
        color: rgba(0, 0, 0, 0.502);
        &:hover {
          color: #b94060;
          &::before {
            color: #000;
            font-weight: 500;
          }
        }
        &::before {
          content: "|";
          font-size: 10px;
          vertical-align: middle;

          //
          margin: 0 0.3rem;
        }
        &:first-child {
          &::before {
            display: none;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 760px) {
  .footer {
    box-sizing: border-box;
    width: 100%;
    padding: 0.8rem 0.3rem;
    .top {
      flex-direction: column;
      .left {
        width: 100%;
        .cmr-location {
          font-size: 14px;
          // text-align: left;
          .icon {
            font-size: 0.5rem;
          }
        }
        .logo {
          img {
            width: 2rem;
          }
        }
        .searchForm {
          font-size: 0.35rem;
          width: 4.4rem;
          input {
            width: 4rem;
            height: 0.8rem;
          }
          .Searchicon {
            font-size: 0.5rem;
          }
        }
        a {
          font-size: 0.4rem;
        }
        .iconSet {
          div {
            display: flex;
            align-items: center;
            font-size: 0.6rem;
          }
        }
      }
      .right {
        flex-direction: column;
        // margin-top: 0.5rem;
        margin-left: 0rem;
        .menuList {
          width: 100%;
          margin-bottom: 0.5rem;
          margin-left: 0;
          .title {
            .link1 {
              font-size: 0.4rem;
            }
          }
          .link {
            // color: #000000;
            font-size: 14px;
          }
          .footer-items {
            width: 100%;
            flex-direction: row;
            flex-wrap: wrap;
            a {
              margin-right: 0.3rem;
            }
          }
        }
      }
    }
    .bottom {
      flex-direction: column;
      .left-bottom {
        font-size: 14px;
      }
      .right-bottom {
        flex-direction: column;
        a {
          width: 100%;
          margin-top: 0.3rem;
          font-size: 14px;
          margin-left: 0rem;
          &::before {
            display: none;
          }
        }
      }
    }
  }
}
</style>
